export const FETCH_PERSON_TEAM_END = "setPersonTeam";
export const LOAD_PERSON_TEAM_TO_EDIT = "loadPersonTeamToEdit";
export const RESET_DEFAULT_PERSON_TEAM_TO_EDIT = "resetDefaultPersonTeamToEdit";
export const RESET_DEFAULT_TEAM_TO_EDIT = "resetDefaultTeam";
export const TOGGLE_EDIT_PERSON_TEAM_DIALOG = "toggleEditPersonTeamDialog";
export const TOGGLE_PERSON_TEAM_EDIT_STATE = "togglePersonTeamEditState";
export const UPDATE_NEW_PERSON_TEAM = "updateNewPersonTeam";
export const UPDATE_PERSON_TEAM_FIELD = "updatePersonTeamField";
